/**
 * @generated SignedSource<<e330858789d41f64d760a285e2b1d98f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Integration_ZohoInfo_Query$variables = {
  salesIqPortalId?: string | null | undefined;
};
export type Integration_ZohoInfo_Query$data = {
  readonly zohoInfo: {
    readonly hasAuth: boolean | null | undefined;
    readonly salesIqAppCode: string | null | undefined;
    readonly salesIqAppId: string | null | undefined;
    readonly salesIqApps: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly salesIqPortalId: string | null | undefined;
    readonly salesIqPortals: ReadonlyArray<{
      readonly createdTime: string | null | undefined;
      readonly id: string | null | undefined;
      readonly logo: string | null | undefined;
      readonly name: string | null | undefined;
      readonly screenName: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type Integration_ZohoInfo_Query = {
  response: Integration_ZohoInfo_Query$data;
  variables: Integration_ZohoInfo_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesIqPortalId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ZohoInfo",
    "kind": "LinkedField",
    "name": "zohoInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasAuth",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ZohoSalesIqPortal",
        "kind": "LinkedField",
        "name": "salesIqPortals",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "screenName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdTime",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "portalId",
            "variableName": "salesIqPortalId"
          }
        ],
        "concreteType": "ZohoSalesIqApp",
        "kind": "LinkedField",
        "name": "salesIqApps",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesIqPortalId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesIqAppId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesIqAppCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_ZohoInfo_Query",
    "selections": (v3/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_ZohoInfo_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "91c41eb32db3da6dc039e3ac5511457e",
    "id": null,
    "metadata": {},
    "name": "Integration_ZohoInfo_Query",
    "operationKind": "query",
    "text": "query Integration_ZohoInfo_Query(\n  $salesIqPortalId: String\n) {\n  zohoInfo {\n    hasAuth\n    salesIqPortals {\n      id\n      name\n      logo\n      screenName\n      createdTime\n    }\n    salesIqApps(portalId: $salesIqPortalId) {\n      id\n      name\n      code\n    }\n    salesIqPortalId\n    salesIqAppId\n    salesIqAppCode\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea4922101eeaa583ac56fa8ee89c2010";

export default node;
